import { render, staticRenderFns } from "./followUpUniformIndent.vue?vue&type=template&id=02b1b5e4&scoped=true"
import script from "./followUpUniformIndent.vue?vue&type=script&lang=js"
export * from "./followUpUniformIndent.vue?vue&type=script&lang=js"
import style0 from "./followUpUniformIndent.vue?vue&type=style&index=0&id=02b1b5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b1b5e4",
  null
  
)

export default component.exports